import ApiBase from './base/ApiBase';

export const NORTHSTAR_TEMPLATE_REPLAY_VERSION = 'northstar-field-service-technician-v1';
export const NORTHSTAR_TEMPLATE_REPLAY_ORGANIZATION = 'Northstar Field Services Training';

export type TemplateFixtureCriterionType = 'Ability' | 'Positive' | 'Counterproductive';

export interface TemplateFixtureReplayCriterion {
    Group: string;
    Type: TemplateFixtureCriterionType;
    IsCounterproductive: boolean;
    Name: string;
    Weight: string;
    SelectedRating: string;
}

export interface TemplateFixtureReplay {
    Version: string;
    IsSynthetic: boolean;
    ReadOnly: boolean;
    OrganizationId: string;
    OrganizationName: string;
    ScenarioName: string;
    TemplateName: string;
    ProficiencyGroups?: readonly string[];
    Criteria: TemplateFixtureReplayCriterion[];
    AbilityLegend: string[];
    BehaviorLegend: string[];
}

export const NORTHSTAR_TEMPLATE_REPLAY_CRITERIA: TemplateFixtureReplayCriterion[] = Object.freeze([
    Object.freeze({ Group: 'Performant', Type: 'Ability', IsCounterproductive: false, Name: 'Inspects commercial equipment systematically', Weight: 'StandardPlusTwo', SelectedRating: 'Advanced' }),
    Object.freeze({ Group: 'Sustainable', Type: 'Ability', IsCounterproductive: false, Name: 'Performs preventive maintenance safely', Weight: 'StandardPlusOne', SelectedRating: 'Advanced' }),
    Object.freeze({ Group: 'Communication', Type: 'Positive', IsCounterproductive: false, Name: 'Documents service findings promptly', Weight: 'Standard', SelectedRating: 'Usually' }),
    Object.freeze({ Group: 'Communication', Type: 'Positive', IsCounterproductive: false, Name: 'Escalates ambiguous safety risks before continuing work', Weight: 'MostImportant', SelectedRating: 'Sometimes' }),
    Object.freeze({ Group: 'Culture', Type: 'Positive', IsCounterproductive: false, Name: 'Shares field knowledge with teammates', Weight: 'Standard', SelectedRating: 'Usually' }),
    Object.freeze({ Group: 'Sustainable', Type: 'Counterproductive', IsCounterproductive: true, Name: 'Proceeds when safety conditions are unclear', Weight: 'MostImportant', SelectedRating: 'Rarely' }),
]) as unknown as TemplateFixtureReplayCriterion[];

export default class TemplateFixtureReplayClient extends ApiBase {
    async Get(signal?: AbortSignal): Promise<TemplateFixtureReplay> {
        return this.GetAsync('Template/FixtureReplay', signal);
    }
}
